export default __webpack_public_path__ + "static/media/TW.0af8ebaa.svg";